<mat-expansion-panel *appHasFeature="features.TAB_USER_TIME_OFF" togglePosition="before" expanded role="region" aria-label="Time Off section">
    <mat-expansion-panel-header>

      <span class="panel-title" appLocalizationPopupDirective localizationCode="Homepage-TimeOff" id="time-off-header">
        {{ 'Homepage-TimeOff' | translate: {Default: "Time Off"} }}
      </span>
    </mat-expansion-panel-header>
  
    <ng-template matExpansionPanelContent>

      <div class="time-off-container" role="group" aria-labelledby="time-off-header">
        <app-time-off-policy-widget (timeOffRequestCreated)="timeOffRequestCreated($event)"></app-time-off-policy-widget>
        
        <app-my-time-off-requests [refreshMyTimeOffRequest]="refreshMyTimeOffRequest"></app-my-time-off-requests>
      </div>

    </ng-template>
</mat-expansion-panel>

<mat-expansion-panel *appHasFeature="features.TAB_TOIL" togglePosition="before" role="region" aria-label="TOIL section">
    <mat-expansion-panel-header>
      <span class="panel-title" appLocalizationPopupDirective localizationCode="Homepage-TOIL" id="toil-header">
        {{ 'Homepage-TOIL' | translate: {Default: "TOIL"} }}
      </span>
    </mat-expansion-panel-header>
  
    <ng-template matExpansionPanelContent>
      <div class="time-off-container" role="group" aria-labelledby="toil-header">
        <app-toil-policy-widget (toilRequestCreated)="toilRequestCreated($event)"></app-toil-policy-widget>
        
        <app-my-toil-requests [refreshMyToilRequest]="refreshMyToilRequest"></app-my-toil-requests>
      </div>
    </ng-template>
</mat-expansion-panel>

<mat-expansion-panel togglePosition="before" *appHasFeature="features.TAB_SCHEDULE" role="region" aria-label="Schedule section">
    <mat-expansion-panel-header>
      <span class="panel-title" appLocalizationPopupDirective localizationCode="Homepage-Schedule" id="schedule-header">
        {{ 'Homepage-Schedule' | translate: {Default: "Schedule"} }}
      </span>
    </mat-expansion-panel-header>
  
    <ng-template matExpansionPanelContent>
      <app-schedule-widget></app-schedule-widget>
    </ng-template>
</mat-expansion-panel>

<mat-expansion-panel togglePosition="before" *appHasFeature="features.TAB_USER_BUY_SELL" role="region" aria-label="Buy/Sell section">
    <mat-expansion-panel-header>
      <span class="panel-title" appLocalizationPopupDirective localizationCode="Homepage-BuySell" id="buy-sell-header">
        {{ 'Homepage-BuySell' | translate: {Default: "Buy/Sell"} }}
      </span>
    </mat-expansion-panel-header>
  
    <ng-template matExpansionPanelContent>
      <app-employee-buy-sell [showTitle]="false" [employeeId]="user$.userId"></app-employee-buy-sell>
    </ng-template>
</mat-expansion-panel>

<!-- <mat-expansion-panel togglePosition="before">
  <mat-expansion-panel-header>
    <h4 appLocalizationPopupDirective localizationCode="TeamMembersSchedule">{{ 'TeamMembersSchedule' | translate: {Default: "Team Members Schedule"} }}</h4>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <app-team-members-schedule-widget></app-team-members-schedule-widget>
  </ng-template>
</mat-expansion-panel> -->


